import { Select } from "antd";
import { ReactEditor, useSlate } from "slate-react";
import { toggleBlock } from "./Buttons";
import { Editor, Element } from "slate";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";
import { CustomElement } from "../slate-types";

const formats = [
  {
    value: "paragraph",
    label: "Paragraph",
  },
  {
    value: "h1",
    label: "Heading 1",
  },
  {
    value: "h2",
    label: "Heading 2",
  },
  {
    value: "h3",
    label: "Heading 3",
  },
  {
    value: "h4",
    label: "Heading 4",
  },
  {
    value: "h5",
    label: "Heading 5",
  },
  {
    value: "h6",
    label: "Heading 6",
  },
];

export const HeadingSelect = ({
  disabled,
  setFontSize,
}: {
  disabled?: boolean;
  setFontSize: (size: string) => void;
}) => {
  const { t } = useTranslation(I18N_NS.RICH_EDITOR);
  const editor = useSlate();
  const [value, setValue] = useState("paragraph");
  const handleChange = (value) => {
    toggleBlock(editor, value);
    setFontSize(getFontSizeForBlockType(value)?.toString());
    setValue(value);
    Editor.removeMark(editor, "fontSize");
    ReactEditor.focus(editor);
  };

  useEffect(() => {
    const selectedNodes = Array.from(
      Editor.nodes(editor, {
        at: editor.selection,
        match: (n) => Element.isElement(n) && formats.some((item) => item.value === n.type),
      })
    );
    if (selectedNodes.length) {
      const selectedValue = (selectedNodes[0][0] as Element).type;
      if (value !== selectedValue) {
        setValue(selectedValue);
      }
    }
  }, [editor?.selection]);

  return (
    <div className="d-flex" title={t("Heading")}>
      <FontAwesomeIcon fixedWidth size="lg" icon={["far", "heading"]} className="mr-sm" />
      <Select
        disabled={disabled}
        value={value}
        size="small"
        style={{ width: 130 }}
        className="mr-1"
        onChange={handleChange}
        options={formats}
      />
    </div>
  );
};

export const getFontSizeForBlockType = (format: CustomElement["type"]) => {
  switch (format) {
    case "h1":
      return 30;
    case "h2":
      return 26;
    case "h3":
      return 22;
    case "h4":
      return 18;
    case "h5":
      return 14;
    case "h6":
      return 10;

    default:
      return undefined;
  }
};
